import { Injectable } from '@angular/core';
import { HttpFileApiService } from 'app/services/api/base/http-file-api.service';
import { Observable } from 'rxjs';
import { CustomerSearchModel } from '@twrx-api-models';

import { CommonApiRoutes, GeneratedFileApiRoutes } from '../api-routes';
import { HttpApiService } from '../base/http-api.service';

@Injectable()
export class GeneratedFileApiService {
	protected rootRoute: string = GeneratedFileApiRoutes.Root;

	constructor(
		protected httpApiService: HttpApiService,
		private readonly httpFileApiService: HttpFileApiService
	) {}

	public getUserFile(
		cancellationSubject: Observable<void>
	): Observable<CustomerSearchModel> {
		return this.httpApiService.get<CustomerSearchModel>(
			this.rootRoute,
			null,
			cancellationSubject
		);
	}

	public downloadFile(
		generatedFileId: number,
		cancellationSubject: Observable<void>
	): Observable<number> {
		return this.httpFileApiService.downloadFile(
			`${this.rootRoute}/${CommonApiRoutes.DownloadFile}`,
			{
				generatedFileId
			},
			cancellationSubject
		);
	}

	public deleteFile(cancellationSubject: Observable<void>): Observable<void> {
		return this.httpApiService.delete(
			this.rootRoute,
			null,
			cancellationSubject
		);
	}
}
